import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/eduegoo/frontend/app/fullExams/FullExamsPage.tsx");
